import React, {useEffect, useState} from 'react';
import './BuyFactorKolAndJoz.scss';
import DynaSelectBox from "../../DynaView/DynaSelectBox";
import DynaInput from "../../DynaView/DynaInput";
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";
import {toast} from "react-toastify";
import BuyFactorJozTable from "./BuyFactorJozTable";
import UtilsFunctions from "../../../../utils/UtilsFunctions";

const BuyFactorJoz = ({initialData, setSendData, sendData, totalPrice}) => {

  const typeMode = [
    {label: "بر اساس نام کالا", value: "name"},
    {label: "بر اساس بارکد", value: "barcode"},
    {label: "بر اساس کد کالای اینترنتی", value: "internetId"},
  ]

  const [modeChanger, setModeChanger] = useState({label: "بر اساس نام کالا", value: "name"});
  const [dataToAdd, setDataToAdd] = useState({
    productId: "",
    name: "",
    number: "1",
    storeId: "",
    storeName: "",
    price: "0",
    discount: "0",
    recordId: ""
  })
  const [productProperty, setProductProperty] = useState({
    colors: [],
    sizes: []
  })
  const [productOptions, setProductOptions] = useState([])

  useEffect(() => {
    if (Object.keys(initialData).length > 0) {
      if (modeChanger.value === "name") {
        setProductOptions(initialData?.productsName)
      } else if (modeChanger.value === "barcode") {
        setProductOptions(initialData?.productsId)
      } else if (modeChanger.value === "internetId") {
        setProductOptions(initialData?.productsInternetId)
      }
      setProductProperty({colors: [], sizes: []})
    }
  }, [modeChanger, initialData]);


  const productSelectHandler = (data) => {

    if (modeChanger.value === "name") {
      let tempColor = []
      let tempSize = []

      if (data?.color.length > 0) {
        data?.color.forEach((v) => {
          tempColor.push({label: v, checked: true})
        })
      }

      if (data?.size.length > 0) {
        data?.size.forEach((v) => {
          tempSize.push({label: v, checked: true})
        })
      }

      setProductProperty({
        colors: [...tempColor],
        sizes: [...tempSize]
      })

    } else {
      setProductProperty({
        colors: [],
        sizes: []
      })
    }

    setDataToAdd({
      ...dataToAdd,
      productId: data.value,
      name: data.label
    })

  }

  const colorChange = (e, data) => {
    let temp = [...productProperty.colors]

    temp.forEach((v) => {
      if (data.label === v.label) {
        v.checked = e.target.checked;
      }
    })
    setProductProperty({...productProperty, colors: temp})

  }

  const sizeChange = (e, data) => {
    let temp = [...productProperty.sizes]

    temp.forEach((v) => {
      if (data.label === v.label) {
        v.checked = e.target.checked;
      }
    })
    setProductProperty({...productProperty, sizes: temp})
  }

  const addDataToTableHandler = async () => {

    if (dataToAdd.storeId === "") {
      return toast.error("انبار را انتخاب کنید")
    }

    if (dataToAdd.productId === "") {
      return toast.error("کالا را انتخاب کنید")
    }

    if (+dataToAdd.price === 0) {
      return toast.error("قیمت را وارد کنید")
    }

    let color = []
    if (productProperty.colors.length > 0) {
      const colorFiltered = productProperty.colors.filter((item) => {
        return item.checked === true
      })
      color = [...colorFiltered]
    }

    let size = []
    if (productProperty.sizes.length > 0) {
      const sizeFiltered = productProperty.sizes.filter((item) => {
        return item.checked === true
      })
      size = [...sizeFiltered]
    }

    const data = {
      type: modeChanger.value,
      value: dataToAdd.productId,
      colors: color,
      sizes: size
    }
    const res = await _axios.post(prefixUrl() + "/buyFactor/?request=productDetail", {...data,});
    if (res.data.status) {
      let temp = [...sendData.tableData]
      res.data.data.forEach((v) => {
        v.storeId = dataToAdd?.storeId
        v.storeName = dataToAdd?.storeName
        v.price = dataToAdd?.price
        v.number = dataToAdd?.number
        v.discount = dataToAdd?.discount
        v.unicId = Math.random() * 13000
        temp.unshift(v)
      })

      const uniqueProductsArray = temp.reduce((uniqueArray, currentObject) => {
        const existingProduct = uniqueArray.find((product) => {
          return +product.productId === +currentObject.productId && product.storeId === currentObject.storeId;
        });

        if (!existingProduct) {
          uniqueArray.push(currentObject);
        }
        return uniqueArray;
      }, []);

      setSendData({...sendData, tableData: uniqueProductsArray})
    } else {
      toast.error(res.data.message)
    }
  }

  const allColorChange = (e) => {
    let temp = [...productProperty.colors]
    if (e.target.checked) {
      temp.forEach((v) => {
        v.checked = true
      })
    } else {
      temp.forEach((v) => {
        v.checked = false
      })
    }

    setProductProperty({...productProperty, colors: temp})
  }

  const allSizeChange = (e) => {
    let temp = [...productProperty.sizes]
    if (e.target.checked) {
      temp.forEach((v) => {
        v.checked = true
      })
    } else {
      temp.forEach((v) => {
        v.checked = false
      })
    }

    setProductProperty({...productProperty, sizes: temp})
  }

  try {
    return (
      <>
        {Object.keys(initialData).length > 0 &&
          <div className="buy-fac-joz">
            <div className={"top-table"}>

              <DynaSelectBox options={initialData?.storesList}
                             hasFilter={false}
                             label={"انتخاب انبار"}
                             className={"solid-dyna-input"}
                             style={{width: '15%'}}
                             value={dataToAdd?.storeId}
                             onChange={(data) => setDataToAdd({
                               ...dataToAdd,
                               storeId: data.value,
                               storeName: data.label
                             })}
              />

              <DynaSelectBox options={typeMode}
                             hasFilter={false}
                             label={"براساس"}
                             className={"solid-dyna-input"}
                             style={{width: '20%'}}
                             value={modeChanger.value}
                             onChange={(data) => {
                               setModeChanger({label: data.label, value: data.value})
                               setDataToAdd({...dataToAdd, productId: "", name: ""})
                             }}
              />

              <DynaSelectBox options={productOptions}
                             hasFilter={true}
                             label={"انتخاب کالا"}
                             className={"solid-dyna-input"}
                             style={{width: '30%'}}
                             value={dataToAdd?.productId}
                             onChange={(data) => productSelectHandler(data)}
              />

              <DynaInput label={"تعداد"}
                         name={"number"}
                         className={"solid-dyna-input"}
                         placeholder={"تعداد"}
                         value={dataToAdd?.number}
                         type={"number"}
                         style={{width: '15%'}}
                         setDataFromComponent={(data) => {
                           if (data.number !== "") {
                             setDataToAdd({...dataToAdd, ...data})
                           } else {
                             setDataToAdd({...dataToAdd, number: 1})
                           }
                         }}
              />

              <DynaInput label={"قیمت"}
                         name={"price"}
                         className={"solid-dyna-input"}
                         placeholder={"قیمت"}
                         value={UtilsFunctions.addCommas(dataToAdd?.price)}
                         hasComma={true}
                         type={"text"}
                         style={{width: '15%'}}
                         setDataFromComponent={(data) => {
                           setDataToAdd({...dataToAdd, ...data})
                         }}
              />

              <div className={"add-to-table"}>
                <button className={"add-to-table"} onClick={addDataToTableHandler}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill="#fff"
                      d="M15 10.625H5A.63.63 0 014.375 10 .63.63 0 015 9.375h10a.63.63 0 01.625.625.63.63 0 01-.625.625z"
                    ></path>
                    <path
                      fill="#fff"
                      d="M10 15.625A.63.63 0 019.375 15V5A.63.63 0 0110 4.375a.63.63 0 01.625.625v10a.63.63 0 01-.625.625z"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>

            {modeChanger.value === "name" &&
              <div className={"checkBox-rows"}>

                <div className={"checkBox-box"}>
                  <label>انتخاب رنگ</label>
                  <div className={"input-checkbox"}>
                    {productProperty.colors.length > 0 &&
                      <>
                        <label key={"Color99"}>
                          <input type={"checkbox"}
                                 defaultChecked={true}
                                 onChange={(e) => allColorChange(e)}/>
                          همه
                        </label>
                        {productProperty.colors.map((v, index) =>
                          <label key={"Color" + index}>
                            <input type={"checkbox"}
                                   checked={v.checked}
                                   onChange={(e) => colorChange(e, v)}/>
                            {v.label}
                          </label>
                        )}
                      </>
                    }
                  </div>
                </div>

                <div className={"checkBox-box"}>
                  <label>انتخاب سایز</label>

                  <div className={"input-checkbox"}>
                    {productProperty.sizes.length > 0 &&
                      <>
                        <label key={"Size99"}>
                          <input type={"checkbox"}
                                 defaultChecked={true}
                                 onChange={(e) => allSizeChange(e)}/>
                          همه
                        </label>

                        {productProperty.sizes.map((v, index) =>
                          <label key={"Size" + index}>
                            <input type={"checkbox"}
                                   checked={v.checked}
                                   onChange={(e) => sizeChange(e, v)}/>
                            {v.label}
                          </label>
                        )}
                      </>
                    }
                  </div>
                </div>
              </div>}

            <div className={"table-side-fac"}>
              <BuyFactorJozTable sendData={sendData} setSendData={setSendData}/>
            </div>

            <div className={"total-price-factor"}>
              <div className={"box-price"}>
                <p>جمع کل :</p>
                <p>{UtilsFunctions.addCommas(totalPrice.sumFactor)}</p>
              </div>
            </div>
          </div>}
      </>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default React.memo(BuyFactorJoz);